var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 42,
    viewBox: "0 0 22 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.931079 41.6706C0.434942 41.2853 0.39594 41.0881 0.667138 40.3692C2.87481 34.5277 5.08248 28.6862 7.29016 22.8447C7.34095 22.7102 7.3863 22.5737 7.45523 22.3776H7.04527C5.13872 22.3776 3.23217 22.3776 1.32563 22.3776C0.566457 22.3776 0.312496 21.9327 0.648091 21.1824C3.67571 14.4298 6.70604 7.67929 9.72912 0.923705C9.91324 0.512161 10.1581 0.327118 10.5772 0.328129C13.739 0.339252 16.9009 0.336218 20.0618 0.332174C20.3666 0.332174 20.6487 0.366553 20.8056 0.704282C20.9607 1.03695 20.8328 1.32109 20.6704 1.60523C18.3966 5.60034 16.1263 9.59848 13.8551 13.5956C13.7717 13.7422 13.691 13.8899 13.5631 14.1184C13.749 14.1184 13.8733 14.1184 13.9975 14.1184C16.158 14.1184 18.3176 14.1184 20.4782 14.1184C20.587 14.1184 20.6958 14.1204 20.8038 14.1184C21.094 14.1133 21.3226 14.2235 21.4459 14.535C21.5638 14.8323 21.4768 15.084 21.3017 15.3156C20.4627 16.4269 19.6246 17.5391 18.7857 18.6504C13.1749 26.0794 7.56407 33.5085 1.94965 40.9334C1.75011 41.1973 1.51338 41.4249 1.29298 41.6696L0.931079 41.6706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeIcon);
export default __webpack_public_path__ + "static/media/chargeIcon.408420d7dcb20b68b080c2c6b4d7903c.svg";
export { ForwardRef as ReactComponent };